var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(_vm._s(_vm.$t("Title_ProfitsAndExpenses")))
    ]),
    _vm._v(" "),
    _vm.report.profitsAndExpenses
      ? _c("div", [
          _vm.hasProcuration
            ? _c(
                "div",
                [
                  _c("percentage-table-row", {
                    attrs: {
                      title: "ProfitsAndExpenses.Profits.Title",
                      instructionKey:
                        "ProfitsAndExpenses.Profits.Title_Instructions",
                      columnHeader: "ProfitsAndExpenses.Profits.ColumnHeader",
                      required: true,
                      items: _vm.report.profitsAndExpenses.profits
                    }
                  }),
                  _vm._v(" "),
                  _c("percentage-table-row", {
                    attrs: {
                      title: "ProfitsAndExpenses.Expenses.Title",
                      instructionKey:
                        "ProfitsAndExpenses.Expenses.Title_Instructions",
                      columnHeader: "ProfitsAndExpenses.Expenses.ColumnHeader",
                      required: true,
                      items: _vm.report.profitsAndExpenses.expenses
                    }
                  })
                ],
                1
              )
            : _c("div", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("ProcurationOnly", {
                        title: _vm.$t("Title_ProfitsAndExpenses")
                      })
                    )
                  )
                ])
              ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }